/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SyncLoader } from "react-spinners";

import {
  AnswerDataProps,
  AnswerSnippetProps,
  CardProps,
  FormProps,
  initCards,
  InputTypes,
  ItemTypeProps,
  SectionProps,
  StateProps,
} from "../../store";
import * as S from "./styles";
import axios from "axios";
import { NeedLogin } from "./styles";
import { API_URL } from "../../config";
import ResultSection from "../../components/ResultSection";

const Result = () => {
  const [answerData, setAnswerData] = useState<AnswerDataProps>();

  const { programId } = useParams();
  const { formAnswerId } = useParams();
  const [sections, setSections] = useState<SectionProps[]>([]);
  const [title, setTitle] = useState<string>("");
  const [accessKey, setAccessKey] = useState<string>("");
  const [hasPermission, setHasPermission] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // localStorage에 에 있으면 꺼내 쓰기
    if (localStorage.getItem("accessKey") !== null) {
      setAccessKey(localStorage.getItem("accessKey")!);
    }

    // 메시지 수신
    const handleMessage = (event: MessageEvent) => {
      // 보낸 페이지의 origin 확인
      const { accessKey } = event.data;
      if (accessKey !== null && accessKey !== undefined) {
        setAccessKey(accessKey);
        localStorage.setItem("accessKey", accessKey);
      }
    };
    window.addEventListener("message", handleMessage);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const getSectionProps = async () => {
    const response = await axios.get(`${API_URL}/forms/${programId}`);
    const form = response.data as FormProps;

    const newSections: SectionProps[] = [];

    form.sections.forEach((section) => {
      const newCards: CardProps[] = [];
      if (section && Array.isArray(section.cards)) {
        section.cards.forEach((card) => {
          if (card.inputType === InputTypes.TITLE) {
            setTitle(card.cardTitle);
          } else if (card.inputType === InputTypes.CHECKBOX) {
            const contents = card.contents as ItemTypeProps[];
            const newContents = [] as ItemTypeProps[];
            for (let i = 0; i < contents.length; i++) {
              const newId = `${contents[i].text}-${contents[i].id}`;
              newContents.push({
                id: newId,
                text: contents[i].text,
                isEtc: contents[i].isEtc,
              });
            }

            newCards.push({
              id: card.id.toString(),
              cardTitle: card.cardTitle,
              inputType: card.inputType,
              contents: newContents,
              subText: card.subText,
              placeholder: card.placeholder,
              isRequired: card.isRequired,
              lengthMin: card.lengthMin,
              isFocused: false,
            });
          } else {
            newCards.push({
              id: card.id.toString(),
              cardTitle: card.cardTitle,
              inputType: card.inputType,
              contents: card.contents,
              subText: card.subText,
              placeholder: card.placeholder,
              isRequired: card.isRequired,
              lengthMin: card.lengthMin,
              isFocused: false,
            });
          }
        });
      }

      if (newCards.length === 0) return;
      if (!section.isTitle) {
        newSections.push({
          formSectionId: section.formSectionId,
          sectionTitle: section.sectionTitle,
          isTitle: section.isTitle,
          cards: newCards,
          teamNumber: section.teamNumber,
        });
      } else {
        newSections.push({
          formSectionId: section.formSectionId,
          sectionTitle: "",
          isTitle: section.isTitle,
          cards: newCards,
          teamNumber: section.teamNumber,
        });
      }
    });

    return newSections;
  };

  const getAnswerProps = async () => {
    if (accessKey === undefined || accessKey === "") {
      throw new Error("Access key is not defined");
    }

    const response = await axios.get(`${API_URL}/forms/answers/${formAnswerId}`, {
      headers: {
        Authorization: `Bearer ${accessKey}`,
      },
    });
    const answer = response.data as AnswerDataProps;
    const answerSnippets = [] as AnswerSnippetProps[];

    answer.answerSnippets.forEach((snippet) => {
      answerSnippets.push({
        formCardId: snippet.formCardId.toString(),
        answer: snippet.answer,
        createdAt: snippet.createdAt,
        url: snippet.url,
        teamIndex: snippet.teamIndex,
      } as AnswerSnippetProps);
    });

    return {
      formAnswerId: answer.formAnswerId,
      formId: answer.formId,
      answerSnippets,
      createdAt: answer.createdAt,
    } as AnswerDataProps;
  };

  useEffect(() => {
    // Fetch data from the server
    console.log("fetch card data from the server");

    const cards = [] as CardProps[];

    getSectionProps().then((res) =>
      res.forEach((section) => {
        section.cards.forEach((card) => {
          cards.push(card);
        });
        dispatch(initCards(cards));
        setSections(res);
      }),
    );
  }, []);

  useEffect(() => {
    // Fetch data from the server
    console.log("fetch answer data from the server");
    getAnswerProps()
      .then((res) => {
        setAnswerData(res);
        setHasPermission(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setHasPermission(false);
      });
  }, [accessKey]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const isAddableSection = (teamNumber: number | undefined) => {
    if (teamNumber === undefined) return false;

    return teamNumber > 1;
  };

  const noTeam = (section: SectionProps) => {
    const cardIdsInSection = section.cards.map((card) => card.id);

    const answer = answerData?.answerSnippets.find((snippet) =>
      cardIdsInSection.includes(snippet.formCardId),
    );

    if (answer === undefined) return true;

    return false;
  };

  return (
    <S.Container>
      <S.SectionTitle>{title}</S.SectionTitle>
      {!hasPermission && !isLoading ? (
        <S.NeedLogin>
          ⚠️ 로그인 정보가 일치하지 않습니다. 어드민 페이지에서 다시 접근해주세요.
          <br />
        </S.NeedLogin>
      ) : null}

      {isLoading ? (
        <S.NeedLogin>
          <SyncLoader /> 로딩중입니다...
        </S.NeedLogin>
      ) : (
        <>
          <S.NoticeTitle>
            * 파일 다운로드가 안될시 화면을 다시 열어주세요. (10분간 유효)
            <br />* 필수항목
          </S.NoticeTitle>
          {sections.map((section) => (
            <S.Section>
              <S.SectionTitle>{section.sectionTitle}</S.SectionTitle>
              {isAddableSection(section.teamNumber) && noTeam(section) && (
                <span
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    padding: "10px 0 0px 15px",
                    marginBottom: "10px",
                    display: "inline-block", // 또는 "block"
                  }}
                >
                  {` 팀원이 없습니다.`}
                </span>
              )}
              {isAddableSection(section.teamNumber) &&
                Array.from({ length: section.teamNumber || 0 }).map((_, i) => (
                  <ResultSection section={section} answerData={answerData} teamNumber={i} />
                ))}
              {!isAddableSection(section.teamNumber) && (
                <ResultSection section={section} answerData={answerData} teamNumber={0} />
              )}
            </S.Section>
          ))}
        </>
      )}
    </S.Container>
  );
};

export default Result;
